import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";

const basePath = `${API_URL.idp}/system/user`;

const getAllSystemUsers = async () => {
  return API.get(basePath, "system_users_list").then(handleResponse);
};

const getSystemUserById = async (userId) => {
  return API.get(`${basePath}/${userId}`, "system_user_by_id").then(handleResponse);
};

const getSystemUserByUsername = async (username) => {
  return API.get(
    `${basePath}/username/${encodeURIComponent(username)}`,
    "system_user_by_username"
  ).then(handleResponse);
};

const changeSystemUserPassword = async (userId, newPassword) => {
  // IAM: PUT …/system/user/changepassword/{id} with { password } (not newPassword).
  return API.put(
    `${basePath}/changepassword/${userId}`,
    "system_user_change_password",
    { password: newPassword }
  ).then(handleResponse);
};

const updateSystemUserRole = async (userId, roles) => {
  return API.put(`${basePath}/role/${userId}`, "system_user_update_role", {
    roles,
  }).then(handleResponse);
};

const createSystemUser = async (payload) => {
  return API.post(basePath, "system_user_create", {
    firstname: payload.firstname,
    lastname: payload.lastname || "",
    username: payload.username,
    email: payload.email,
    password: payload.password,
    roles: payload.roles,
    ...(payload.mobile ? { mobile: payload.mobile } : {}),
  }).then(handleResponse);
};

const updateSystemUser = async (userId, payload) => {
  // IAM rejects empty strings (min length 1). Omit optional lastname when blank.
  const lastname = String(payload.lastname || "").trim();
  const body = {
    firstname: payload.firstname,
    username: payload.username,
    email: payload.email,
    mobile: payload.mobile || "",
    enabled: Boolean(payload.enabled),
  };
  if (lastname) {
    body.lastname = lastname;
  }
  return API.put(`${basePath}/${userId}`, "system_user_update", body).then(
    handleResponse
  );
};

const deleteSystemUser = async (userId) => {
  if (!userId) {
    throw new Error("User id is missing.");
  }
  return API.delete(`${basePath}/${userId}`, "system_user_delete").then(
    handleResponse
  );
};

export const systemUserService = {
  getAllSystemUsers,
  getSystemUserById,
  getSystemUserByUsername,
  changeSystemUserPassword,
  updateSystemUserRole,
  createSystemUser,
  updateSystemUser,
  deleteSystemUser,
};
